import { AUTH_REQUEST_BBVA } from 'store/actions/auth';
import { UI_SET_LOADER_TEXT } from 'store/actions/ui';
import {
  BBVA_OFFER_INIT_RESPONSE,
  BBVA_THREE_LEG_AUTHENTICATION,
  SET_BBVA_PROPERTY,
  SET_BBVA_ACCOUNTS,
  BBVA_CUSTOMER_ME_FULL,
  BBVA_CUSTOMER_GLOBAL_POSITION,
  BBVA_OFFER_INIT_RESPONSE_SUMMARY,
  BBVA_AUTHENTICATION_FOR_SUMMARY,
  BBVA_OFFER_INIT_RESPONSE_CONFIRM,
  BBVA_AUTHENTICATION_FOR_CONFIRM,
  BBVA_LOGIN
} from 'store/actions/bbva';
import {
  OFFER_SET_CURRENT_STEP,
  OFFER_UPDATE_PARAMS,
  OFFER_CAMPAIGN_BY_ID,
  OFFER_CAMPAIGN_BY_GUID,
  OFFER_CREATE_OPERATION,
  OFFER_DOCUMENTS_REQUIRED_BY_GUID,
  OFFER_UPDATE_OPERATION_ID
} from 'store/actions/offer';

import { UPDATE_OPERATION_PROSPECT_TO_BBVA } from 'store/actions/operation';
import { OFFER_COOKIE_TO_PAGE } from 'store/enums';
import { bbva } from 'api';
import {
  lsSetOfferGuid,
  lsGetOfferGuid,
  lsSetTicketBBVA,
  lsGetTicketBBVA,
  lsRemoveTicketBBVA,
  lsRemoveAuthTokenBBVA,
  lsSetAuthTokenBBVA
} from 'helpers/store';

export default {
  [SET_BBVA_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_BBVA_PROPERTY, {
      field,
      value
    }),

  [BBVA_OFFER_INIT_RESPONSE]: ({ commit, dispatch }, { params, query }) => {
    commit(SET_BBVA_PROPERTY, { field: 'codeBBVA', value: query.code });
    commit(`offer/${OFFER_UPDATE_PARAMS}`, params, { root: true });
    return new Promise((resolve, reject) => {
      dispatch(`auth/${AUTH_REQUEST_BBVA}`, null, { root: true })
        .then(() => dispatch(BBVA_THREE_LEG_AUTHENTICATION))
        .catch(err => reject(err));
    });
  },

  [BBVA_OFFER_INIT_RESPONSE_SUMMARY]: ({ dispatch }) => dispatch(BBVA_AUTHENTICATION_FOR_SUMMARY),

  [BBVA_OFFER_INIT_RESPONSE_CONFIRM]: ({ commit, dispatch }, { query }) => {
    commit(SET_BBVA_PROPERTY, { field: 'codeBBVA', value: query.code });
    return dispatch(BBVA_AUTHENTICATION_FOR_CONFIRM);
  },

  [BBVA_THREE_LEG_AUTHENTICATION]: ({ commit, dispatch, rootGetters }, data) =>
    new Promise((resolve, reject) => {
      dispatch(`ui/${UI_SET_LOADER_TEXT}`, 'Analizando viabilidad de la operación', {
        root: true
      });
      // const lsAuthTokenBBVA = lsGetAuthTokenBBVA();
      bbva
        .access(
          rootGetters['offer/getOfferField']('partnerId'),
          rootGetters['offer/getOfferField']('idOffer'),
          {
            // code: getters.getBBVADataField('codeBBVA'),
            // token: lsAuthTokenBBVA.refresh_token,
            // tokenType: lsAuthTokenBBVA.token_type,
            email: data ? data.email : '',
            mobile: data ? data.mobile : ''
          }
        )
        .then(
          resp => {
            if (resp.status === 200) {
              dispatch(`ui/${UI_SET_LOADER_TEXT}`, 'Solicitando datos del cliente', {
                root: true
              });
              // lsAuthTokenBBVA.refresh_token = resp.headers['auth-btk-refresh'];
              // lsSetAuthTokenBBVA(lsAuthTokenBBVA);
              dispatch(BBVA_CUSTOMER_ME_FULL).then(
                // eslint-disable-next-line max-nested-callbacks
                respMeFull => {
                  const { url } = respMeFull;
                  if (url) {
                    resolve({ routerName: 'redirect', url }); // Hace la redirección a la url de 2FA de bbva en el vue que llama al mefull con el processResp
                  } else {
                    resolve(respMeFull);
                  }
                },
                // eslint-disable-next-line max-nested-callbacks
                err => reject(err)
              );
            } else {
              reject();
            }
          },
          err => {
            lsRemoveAuthTokenBBVA();
            if (
              err.response.status === 412 &&
              err.response.data.step.toString().toLowerCase() === '5c'
            ) {
              dispatch(`offer/${OFFER_DOCUMENTS_REQUIRED_BY_GUID}`, err.response.data.currentGuid, {
                root: true
              })
                .then(() => {
                  const cookieToPage =
                    OFFER_COOKIE_TO_PAGE[err.response.data.step.toString().toLowerCase()];
                  commit(`offer/${OFFER_SET_CURRENT_STEP}`, cookieToPage.step, {
                    root: true
                  });
                  commit(`offer/${OFFER_UPDATE_OPERATION_ID}`, err.response.data.operationId, {
                    root: true
                  });
                  resolve({ routerName: cookieToPage.routerName });
                })
                .catch(error => reject(error));
            } else if (err.response.status === 412) {
              dispatch(`offer/${OFFER_CAMPAIGN_BY_ID}`, null, {
                root: true
              }).then(
                () => {
                  commit(`offer/${OFFER_SET_CURRENT_STEP}`, 0, {
                    root: true
                  });
                  dispatch(`ui/${UI_SET_LOADER_TEXT}`, null, {
                    root: true
                  });
                  /** The GUID '00000000-0000-0000-0000-000000000001' is the
                   * error 'Your operation is not possible'
                   */
                  lsSetOfferGuid('00000000-0000-0000-0000-000000000001');
                  resolve({ routerName: 'step-4-ko' });
                },
                errOffer => reject(errOffer)
              );
            } else {
              reject(err);
            }
          }
        );
    }),

  [BBVA_AUTHENTICATION_FOR_SUMMARY]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(`offer/${OFFER_CAMPAIGN_BY_GUID}`, null, {
        root: true
      }).then(
        () => {
          const cookieToPage = OFFER_COOKIE_TO_PAGE['6'];
          commit(`offer/${OFFER_SET_CURRENT_STEP}`, cookieToPage.step, {
            root: true
          });
          resolve({
            routerName: cookieToPage.routerName
          });
        },
        err => reject(err)
      );
    }),

  [BBVA_AUTHENTICATION_FOR_CONFIRM]: ({ commit, dispatch }) =>
    // eslint-disable-next-line no-unused-vars
    new Promise((resolve, reject) => {
      dispatch(`auth/${AUTH_REQUEST_BBVA}`, null, { root: true }).then(
        () => {
          const cookieToPage = OFFER_COOKIE_TO_PAGE['6confirm'];
          commit(`offer/${OFFER_SET_CURRENT_STEP}`, cookieToPage.step, {
            root: true
          });
          resolve({
            routerName: cookieToPage.routerName
          });
        },
        err => reject(err)
      );
    }),

  [BBVA_CUSTOMER_ME_FULL]: ({ commit, dispatch, rootGetters }, options) =>
    new Promise((resolve, reject) => {
      bbva.customerMeFull(options).then(
        resp => {
          const { result, data } = resp.data;
          if (result) {
            const { code, info } = result;
            if (code === 200) {
              const lsTicketBBVA = lsGetTicketBBVA();
              if (lsTicketBBVA) {
                commit(`offer/${OFFER_UPDATE_PARAMS}`, lsTicketBBVA, {
                  root: true
                });
                lsRemoveTicketBBVA();
              }
              commit(`operation/${UPDATE_OPERATION_PROSPECT_TO_BBVA}`, data, {
                root: true
              });
              dispatch(`offer/${OFFER_CREATE_OPERATION}`, null, { root: true })
                .then(res => resolve(res))
                .catch(() => reject());
            } else if (code === 428) {
              const { url } = data;
              lsSetTicketBBVA({
                idOffer: rootGetters['offer/getOfferField']('idOffer'),
                idc: rootGetters['offer/getOfferField']('idc') || '',
                partnerId: rootGetters['offer/getOfferField']('partnerId')
              });
              resolve({
                url
              });
            } else {
              lsRemoveTicketBBVA();
              commit('ERROR_OCCURRED', info, { root: true });
              reject();
            }
          } else {
            lsRemoveTicketBBVA();
            commit('ERROR_OCCURRED', { message: 'Result without data' }, { root: true });
            reject();
          }
        },
        err => {
          lsRemoveTicketBBVA();
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [BBVA_CUSTOMER_GLOBAL_POSITION]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(`ui/${UI_SET_LOADER_TEXT}`, 'Solicitando cuentas del cliente al BBVA', {
        root: true
      });
      bbva.fetchAccounts(lsGetOfferGuid()).then(
        resp => {
          const { result, data } = resp.data;
          if (result.code === 200) {
            const { accounts = [] } = data;
            commit(SET_BBVA_ACCOUNTS, accounts);
            resolve();
          } else {
            commit('ERROR_OCCURRED', { message: result.info }, { root: true });
            reject();
          }
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [BBVA_LOGIN]: ({ commit }, { idOffer }) =>
    // eslint-disable-next-line no-unused-vars
    new Promise((resolve, reject) => {
      bbva.getUrlBBVA(idOffer).then(
        resp => {
          const { urlRedirect, code } = resp.data;
          lsSetAuthTokenBBVA(code); // Guardar el code como token que luego viaja en auth-btk siempre
          resolve({
            urlRedirect
          });
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    })
};
